import { Link } from "react-router-dom";
import { Logo } from "../assets/images";

const AuthImages = () => {
    return (
        <div className="auth-images">
            <Link to='/' className="logo">
                <img src={Logo} alt="Logo" />
            </Link>
            <h1>Get started — add, manage, and track profitable property deals.</h1>
            <p>Track renovations, market valuations, and investor activities all in one powerful dashboard.</p>
        </div>
    );
}

export default AuthImages;